<template>
  <div
    class="form-group-special input-group flex-nowrap justify-content-between"
    :class="{ 'disabled-numeric__button': disabled }"
    style="max-width: unset"
  >
    <span class="input-group-prepend">
      <s-button @click="changeQuantity(-1)" class="btn btn-light btn-icon"><minus-icon/></s-button>
    </span>
    <s-numeric-input
      class="text-center overflow-hidden"
      v-model="modelValue"
      :style="dynamicWidth ? dynamicInputWidth : ''"
      ref="input"
      :format="format"
      :disabled="disabled"
      :allow-minus="allowMinus"
    />
    <span class="input-group-append">
      <s-button @click="changeQuantity(1)" class="btn btn-light btn-icon"><plus-icon/></s-button>
    </span>
  </div>
</template>
<script setup>
  import MinusIcon from '@/components/icons/minus';
  import PlusIcon from '@/components/icons/plus';
  import BigNumber from 'bignumber.js';
  import { computed } from 'vue';

  const props = defineProps({
    modelValue: {
      type: null,
      required: true,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    format: {
      required: false,
      type: String,
      default: '0.[00]',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dynamicWidth: {
      type: Boolean,
      default: true,
    },
    allowMinus: {
      required: false,
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const dynamicInputWidth = computed(() => {
    if (props.modelValue) {
      return `width: ${props.modelValue.toString().length + 4}ch;`;
    }

    return 'width: 5ch;';
  });

  const modelValue = computed({
    get: () => props.modelValue,
    set: (value) => _updateInputValue(value),
  });

  function changeQuantity(change) {
    if (!props.disabled) {
      let value = props.modelValue;

      // in case value is empty or null
      if (!value) {
        value = 0;
      }

      if (value.toString().length === 1 && value.toString().substring(0, 1) === '-') {
        value = 0;
      }

      const result = getAllowedValue(new BigNumber(value).plus(change));

      emit('update:modelValue', result.toFixed());
    }
  }

  function _updateInputValue(value) {
    if (props.min !== null && value < props.min) {
      emit('update:modelValue', new BigNumber(props.min));
    } else if (props.max !== null && value > props.max) {
      emit('update:modelValue', new BigNumber(props.max));
    } else {
      emit('update:modelValue', value);
    }
  }

  function getAllowedValue(value) {
    let result = value;
    if (typeof props.min === 'number' && result.isLessThanOrEqualTo(props.min)) {
      result = new BigNumber(props.min);
    }

    if (typeof props.max === 'number' && result.isGreaterThanOrEqualTo(props.max)) {
      result = new BigNumber(props.max);
    }

    return result;
  }
</script>


